<template>
  <div class="card mb-25 border-0 rounded-0 bg-white">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30">
      <h4 class="mb-4">Soumettre un devoir</h4>

      <Form
        ref="devoirForm"
        @submit="submitDevoir"
        :validation-schema="devoirSchema"
      >
        <div class="row mb-20">
          <!-- Date de soumission  -->
          <div class="col-md-6">
            <div class="form-group mb-0">
              <label class="d-block text-black fw-semibold mb-10">
                Date de soumission
              </label>
              <div class="position-relative">
                <input
                  type="text"
                  class="form-control bg-light text-muted"
                  :value="formatDate(today)"
                  disabled
                  style="cursor: not-allowed;"
                />
              </div>
            </div>
          </div>

          <!-- Composition -->
          <div class="col-md-6">
            <div class="form-group mb-0">
              <label class="d-block text-black fw-semibold mb-10">
                Composition <span class="text-danger">*</span>
              </label>
              <Field name="composition" v-slot="{ field }">
                <Multiselect
                  :options="compositionsOptions"
                  :searchable="true"
                  track-by="value"
                  label="label"
                  v-bind="field"
                  @change="onCompositionChange"
                  placeholder="Sélectionner une composition"
                  :disabled="compositionsOptions.length === 0"
                  :canDeselect="false"
                  :classes="{
                    option: 'multiselect-option-custom',
                    optionDisabled: 'multiselect-option-disabled'
                  }"
                >
                  <template #option="{ option }">
                    <div :class="['composition-option', { 'expired': option.estExpire, 'urgent': !option.estExpire && option.joursRestants <= 3 }]">
                      <div class="d-flex align-items-start gap-3">
                        <!-- Contenu principal -->
                        <div class="flex-grow-1">
                          <div class="fw-bold mb-1">{{ option.titre }}</div>
                          <div class="text-muted small">
                            <i class="fa fa-book me-1"></i>{{ option.matiere }}
                            <span class="mx-2">•</span>
                            <i class="fa fa-graduation-cap me-1"></i>{{ option.filiere }} - {{ option.niveau }}
                          </div>
                        </div>
                        
                        <!-- Badge de statut -->
                        <div class="flex-shrink-0 align-self-center">
                          <span v-if="option.estExpire" class="badge bg-danger">
                            <i class="fa fa-times-circle me-1"></i>Expiré
                          </span>
                          <span v-else-if="option.joursRestants <= 3" class="badge bg-warning text-dark">
                            <i class="fa fa-clock-o me-1"></i>{{ option.joursRestants }}j
                          </span>
                          <span v-else class="badge bg-success">
                            <i class="fa fa-check-circle me-1"></i>{{ option.joursRestants }}j
                          </span>
                        </div>
                      </div>
                    </div>
                  </template>
                </Multiselect>
              </Field>
              <ErrorMessage name="composition" class="text-danger"/>
              
              <!-- Message si aucune composition disponible -->
              <div v-if="compositionsOptions.length === 0 && !isLoadingCompositions" class="alert alert-warning mt-2 py-2">
                <i class="fa fa-exclamation-triangle me-2"></i>
                <small>Aucune composition de type Questions/Réponses n'est disponible pour le moment.</small>
              </div>
              
              <!-- Message de chargement -->
              <div v-if="isLoadingCompositions" class="text-muted mt-2">
                <small><i class="fa fa-spinner fa-spin me-1"></i> Chargement des compositions...</small>
              </div>
            </div>
          </div>
        </div>

        <!-- Détails de la composition sélectionnée -->
       <div v-if="selectedComposition" :class="['alert mb-20', selectedComposition.estExpire ? 'alert-danger' : 'alert-info']">
         
        <!-- <h6 class="mb-3">
            <i class="fa fa-info-circle me-2"></i>Détails de la composition
            <span v-if="selectedComposition.estExpire" class="badge bg-danger ms-2">
              <i class="fa fa-exclamation-triangle me-1"></i>EXPIRÉ
            </span>
            <span v-else-if="selectedComposition.joursRestants <= 3" class="badge bg-warning text-dark ms-2">
              <i class="fa fa-clock-o me-1"></i>Urgent - {{ selectedComposition.joursRestants }} jour(s) restant(s)
            </span>
          </h6>-->
           <!--  <div class="row">
            <div class="col-md-6">
              <p class="mb-2"><strong>Titre :</strong> {{ selectedComposition.titre }}</p>
              <p class="mb-2"><strong>Matière :</strong> {{ selectedComposition.matiere }}</p>
              <p class="mb-2">
                <strong>Type :</strong> 
                <span class="badge bg-success">
                  <i class="fa fa-file-text-o me-1"></i>Questions/Réponses
                </span>
              </p>
            </div>
            <div class="col-md-6">
              <p class="mb-2"><strong>Filière :</strong> {{ selectedComposition.filiere }}</p>
              <p class="mb-2"><strong>Niveau :</strong> {{ selectedComposition.niveau }}</p>
              <p class="mb-2"><strong>Date de composition :</strong> {{ formatDate(selectedComposition.dateComposition) }}</p>
              <p class="mb-2">
                <strong>Date limite :</strong> 
                <span :class="selectedComposition.estExpire ? 'text-danger fw-bold' : ''">
                  {{ formatDate(selectedComposition.dateFinSoumission || selectedComposition.dateComposition) }}
                </span>
              </p>
            </div>
          </div>-->
          
          <!-- Message d'avertissement si expiré -->
          <div v-if="selectedComposition.estExpire" class="alert alert-danger mt-3 mb-0">
            <i class="fa fa-ban me-2"></i>
            <strong>Cette composition est expirée.</strong> Vous ne pouvez plus soumettre de devoir.
          </div>
          <div v-else-if="selectedComposition.joursRestants <= 3" class="alert alert-warning mt-3 mb-0">
            <i class="fa fa-exclamation-triangle me-2"></i>
            <strong>Attention !</strong> Il ne reste que {{ selectedComposition.joursRestants }} jour(s) pour soumettre votre devoir.
          </div>
        </div>

        <!-- Upload du fichier PDF -->
        <div class="row">
          <div class="col-md-12">
            <div class="form-group mb-20">
              <label class="d-block text-black fw-semibold mb-10">
                Fichier PDF du devoir <span class="text-danger">*</span>
              </label>
              <div class="upload-area" @click="triggerFileInput" :class="{ 'has-file': selectedFile }">
                <input
                  type="file"
                  ref="fileInput"
                  @change="handleFileUpload"
                  accept=".pdf"
                  style="display: none;"
                />
                <div v-if="!selectedFile" class="upload-placeholder">
                  <i class="fa fa-cloud-upload fa-3x text-primary mb-3"></i>
                  <p class="mb-2"><strong>Cliquez pour sélectionner un fichier PDF</strong></p>
                  <p class="text-muted small">ou glissez-déposez votre fichier ici</p>
                  <p class="text-muted small">Taille maximale : 20 Mo</p>
                </div>
                <div v-else class="file-preview">
                  <i class="fa fa-file-pdf-o fa-3x text-danger mb-2"></i>
                  <p class="mb-1"><strong>{{ selectedFile.name }}</strong></p>
                  <p class="text-muted small">{{ formatFileSize(selectedFile.size) }}</p>
                  <button 
                    type="button" 
                    class="btn btn-sm btn-danger mt-2"
                    @click.stop="removeFile"
                  >
                    <i class="fa fa-trash me-1"></i> Supprimer
                  </button>
                </div>
              </div>
              <ErrorMessage name="fichier" class="text-danger"/>
            </div>
          </div>
        </div>

        <!-- Boutons d'action -->
        <div class="row">
          <div class="col-md-12">
            <div class="d-flex align-items-center gap-2">
              <button
                class="btn btn-success"
                type="submit"
                :disabled="isSubmitting || !selectedFile || !selectedComposition || selectedComposition?.estExpire"
              >
                <span v-if="isSubmitting" class="spinner-border spinner-border-sm me-2"></span>
                <i v-else class="fa fa-paper-plane me-2"></i>
                {{ isSubmitting ? 'Soumission en cours...' : 'Soumettre le devoir' }}
              </button>
              <router-link
                to="/mes-devoirs"
                class="btn btn-secondary"
              >
                <i class="fa fa-times me-1"></i> Annuler
              </router-link>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import { success, error } from "../../utils/utils";
import { useRouter } from "vue-router";
import ApiService from "../../services/ApiService";
import * as Yup from "yup";
import Multiselect from '@vueform/multiselect';

export default defineComponent({
  name: "SubmitDevoir",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect,
  },
  setup() {
    const devoirSchema = Yup.object().shape({
      composition: Yup.number().required("Veuillez sélectionner une composition"),
      fichier: Yup.mixed().required("Veuillez sélectionner un fichier PDF"),
    });

    const today = new Date();
    const devoirForm = ref<any>(null);
    const fileInput = ref<any>(null);
    const router = useRouter();
    const compositionsOptions = ref<any[]>([]);
    const selectedComposition = ref<any>(null);
    const selectedFile = ref<File | null>(null);
    const isSubmitting = ref(false);
    const isLoadingCompositions = ref(false);

    onMounted(() => {
  fetchCompositions();
});

    const fetchCompositions = async () => {
      isLoadingCompositions.value = true;
      try {
        const response = await ApiService.get('/devoirs/compositions-disponibles');
        const compositions = response.data.data;

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        compositionsOptions.value = compositions.map((comp: any) => {
          const dateFin = comp.dateFinSoumission ? new Date(comp.dateFinSoumission) : new Date(comp.dateComposition);
          dateFin.setHours(23, 59, 59, 999);
          const joursRestants = Math.ceil((dateFin.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));

          return {
            value: comp.id,
            label: joursRestants <= 3
              ? `${comp.titre} - ${comp.matiere} (${joursRestants}j restants)`
              : `${comp.titre} - ${comp.matiere}`,
            titre: comp.titre,
            dateComposition: comp.dateComposition,
            dateFinSoumission: comp.dateFinSoumission,
            type: comp.type,
            // ✅ Correction : ce sont déjà des chaînes directes renvoyées par le backend
            matiere: comp.matiere || 'N/A',
            filiere: comp.filiere || 'N/A',
            niveau: comp.niveau || 'N/A',
            estExpire: comp.estExpire ?? false,
            joursRestants,
            disabled: false
          };
        });

      } catch (err) {
        console.error("Erreur lors du chargement des compositions", err);
        error("Impossible de charger les compositions");
        compositionsOptions.value = [];
      } finally {
        isLoadingCompositions.value = false;
      }
    };


    const onCompositionChange = (value: any) => {
      const composition = compositionsOptions.value.find(c => c.value === value);
      selectedComposition.value = composition || null;
      
      if (selectedComposition.value) {
        console.log('Composition sélectionnée:', {
          id: selectedComposition.value.value,
          titre: selectedComposition.value.titre,
          type: selectedComposition.value.type,
          estExpire: selectedComposition.value.estExpire,
          joursRestants: selectedComposition.value.joursRestants
        });
      }
    };

    const triggerFileInput = () => {
      if (!selectedFile.value) {
        fileInput.value?.click();
      }
    };

    const handleFileUpload = async (event: any) => {
      const file = event.target.files[0];
      if (!file) return;

      if (file.type !== 'application/pdf') {
        error("Veuillez sélectionner un fichier PDF valide");
        return;
      }

      const maxSize = 20 * 1024 * 1024;
      if (file.size > maxSize) {
        error("Le fichier ne doit pas dépasser 20 Mo");
        return;
      }

      selectedFile.value = file;
      await devoirForm.value?.setFieldValue('fichier', file);
    };

    const removeFile = () => {
      selectedFile.value = null;
      if (fileInput.value) {
        fileInput.value.value = '';
      }
      devoirForm.value?.setFieldValue('fichier', null);
    };

    const formatDate = (date: string | Date) => {
      return new Date(date).toLocaleString('fr-FR', {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    };

    const formatFileSize = (bytes: number) => {
      if (bytes < 1024) return bytes + ' B';
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(2) + ' KB';
      return (bytes / (1024 * 1024)).toFixed(2) + ' MB';
    };

    const submitDevoir = async (values: any) => {
      if (!selectedFile.value || !selectedComposition.value) {
        error("Veuillez remplir tous les champs obligatoires");
        return;
      }

      if (selectedComposition.value.estExpire) {
        error("Cette composition est expirée. Vous ne pouvez plus soumettre de devoir.");
        return;
      }

      if (selectedComposition.value.type !== 'QuestionsReponses') {
        error("Seules les compositions de type Questions/Réponses peuvent être soumises");
        return;
      }

      isSubmitting.value = true;

      try {
        const formData = new FormData();
        formData.append('fichier', selectedFile.value);
        formData.append('compositionId', values.composition.toString());

        const response = await ApiService.post('/devoirs', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });

        if (response.data.code === 201) {
          success("Devoir soumis avec succès !");
          router.push('/mes-devoirs');
        }
      } catch (err: any) {
        console.error("Erreur lors de la soumission:", err);
        if (err.response?.data?.message) {
          error(err.response.data.message);
        } else if (err.response?.status === 400) {
          error("Vous avez déjà soumis un devoir pour cette composition");
        } else {
          error("Impossible de soumettre le devoir");
        }
      } finally {
        isSubmitting.value = false;
      }
    };

    return {
      today,
      devoirSchema,
      devoirForm,
      fileInput,
      compositionsOptions,
      selectedComposition,
      selectedFile,
      isSubmitting,
      isLoadingCompositions,
      onCompositionChange,
      triggerFileInput,
      handleFileUpload,
      removeFile,
      formatDate,
      formatFileSize,
      submitDevoir,
    };
  },
});
</script>

<style scoped>
.upload-area {
  border: 2px dashed #cbd5e1;
  border-radius: 12px;
  padding: 2rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
  background: #f8fafc;
}

.upload-area:hover {
  border-color: #6366f1;
  background: #f0f0ff;
}

.upload-area.has-file {
  border-color: #10b981;
  background: #f0fdf4;
  cursor: default;
}

.upload-placeholder {
  color: #64748b;
}

.file-preview {
  color: #1e293b;
}

.composition-option {
  padding: 0.75rem 1rem;
  transition: background-color 0.2s;
  border-radius: 6px;
  margin: 2px 0;
}

.composition-option.expired {
  opacity: 0.6;
  background-color: #fee2e2;
}

.composition-option.urgent {
  background-color: #fef3c7;
}

.composition-option:hover:not(.expired) {
  background-color: #f0f9ff;
}

.multiselect-option-disabled {
  cursor: not-allowed !important;
  opacity: 0.5;
}

:deep(.multiselect-option-custom) {
  padding: 0 !important;
}

:deep(.multiselect-options) {
  padding: 0.25rem;
}
</style>